import React, { useState } from "react";
import {
  View,
  Text,
  TouchableOpacity,
  StyleSheet,
  Image,
  Modal,
  FlatList,
} from "react-native";
import { AppImages } from "../../../utility/AppImages";
import { AppFontStyle } from "../../../styles/AppFontStyle";
import { AppColors } from "../../../utility/AppColors";

const FilterDropdown = ({ onFilterChange }) => {
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [selectedOption, setSelectedOption] = useState({
    value: "",
    title: "Filter",
  });

  // Define options with value and title
  const options = [
    { value: "today", title: "Today" },
    { value: "this_week", title: "This Week" },
    { value: "resolved", title: "Resolved" },
    { value: "pending", title: "Pending" },
  ];

  const toggleDropdown = () => {
    setIsDropdownVisible(!isDropdownVisible);
  };

  const selectOption = (option) => {
    setSelectedOption(option);
    setIsDropdownVisible(false);
    if (onFilterChange) {
      onFilterChange(option.value);
    }
  };

  return (
    <View style={styles.container}>
      {/* Dropdown Button */}
      <TouchableOpacity style={styles.dropdownButton} onPress={toggleDropdown}>
        <Image
          source={AppImages.icFilter}
          style={styles.icon}
          resizeMode="contain"
        />
        <Text style={[AppFontStyle.REGULAR_ANYBODY_14, styles.buttonText]}>
          {selectedOption.title}
        </Text>
        <Image
          source={AppImages.icChevronDown}
          style={[styles.icon]}
          resizeMode="contain"
        />
      </TouchableOpacity>

      {/* Dropdown Options in Modal */}
      <Modal
        visible={isDropdownVisible}
        transparent={true}
        animationType="fade"
        onRequestClose={() => setIsDropdownVisible(false)}
      >
        <TouchableOpacity
          style={styles.modalOverlay}
          onPress={() => setIsDropdownVisible(false)}
        >
          <View style={styles.dropdownMenu}>
            <FlatList
              data={options}
              keyExtractor={(item, index) => `${item.value}-${index}`}
              renderItem={({ item }) => (
                <TouchableOpacity
                  style={[
                    styles.option,
                    item.value === selectedOption.value &&
                      styles.selectedOption,
                  ]}
                  onPress={() => selectOption(item)}
                >
                  <Text
                    style={[
                      AppFontStyle.REGULAR_ANYBODY_14,
                      //   styles.optionText,
                      //   item.value === selectedOption.value && {
                      //     color: AppColors.white,
                      //   },
                    ]}
                  >
                    {item.title}
                  </Text>
                </TouchableOpacity>
              )}
            />
          </View>
        </TouchableOpacity>
      </Modal>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    position: "relative",
  },
  dropdownButton: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    paddingHorizontal: 12,
    paddingVertical: 8,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: AppColors.purple_453B50,
  },
  buttonText: {
    color: AppColors.white,
    marginLeft: 8,
    flex: 1,
  },
  icon: {
    width: 24,
    height: 24,
    tintColor: AppColors.white,
  },
  modalOverlay: {
    flex: 1,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    justifyContent: "flex-start",
    alignItems: "flex-end",
    paddingTop: 180,
    paddingRight: 20,
  },
  dropdownMenu: {
    width: 186,
    backgroundColor: AppColors.gray_353535,
    borderRadius: 12,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.3,
    shadowRadius: 4,
    elevation: 10,
  },
  option: {
    paddingVertical: 12,
    paddingHorizontal: 24,
  },
  selectedOption: {
    backgroundColor: AppColors.purple_453B50,
    borderRadius: 10,
  },
});

export default FilterDropdown;
